<template>
<div style="margin:5px;">
      <br>
     <Row><Col span="12" offset="10"><div class="myTitle" >IP白名单列表</div></Col></Row>
            <Row>
                <div class="queryForm">
                    <!--Form ref="queryFormRef" :model="queryForm" :label-width="60" inline>
                      
                       
                        <FormItem label="IP地址" prop="ip" >
                            <Input v-model="queryForm.ip" placeholder="IP地址 "></Input>
                        </FormItem>
                      
                        <FormItem label="用户名" prop="username" >
                            <Input v-model="queryForm.username" placeholder="用户名"></Input>
                        </FormItem>
                          <FormItem label="时间" prop="queryStartDate" >
                            <DatePicker type="date" placeholder="开始时间" format="yyyy-MM-dd"
                            v-model="queryForm.queryStartDate" @on-change="queryForm.queryStartDate=$event" ></DatePicker>
                        </FormItem>
                        <FormItem label="—" prop="queryEndDate"  :label-width="30">
                              <DatePicker type="date" placeholder="结束时间"
                              v-model="queryForm.queryEndDate" format="yyyy-MM-dd"  @on-change="queryForm.queryEndDate=$event" ></DatePicker>
                        </FormItem>
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form-->
                </div>
            </Row>
     
      <Row >
          <Col span="10" offset="1">
            <div>
              <Button type="info"  @click="openAddForm" >新增</Button>
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
               
                  <Button type="info" size="small" @click="openUpdateForm(row)">修改</Button>
                  <Button type="error" size="small" @click="deleleRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <IPEdit ref="ipEdit"></IPEdit>
 
</div>
</template>

<script>

  import IPEdit from '@/pages/platform/security/IPEdit';


  export default {
    components: {
        IPEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        this.$refs.ipEdit.openModal('新增',null);
      },
      //打开修改对话框
      openUpdateForm(row) {
        this.$refs.ipEdit.openModal('修改',row);
       
      },
 
    //执行删除操作
            deleleRows(row) {
               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除\"${row.ip}\"吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/safeIP`
                            this.req({
                                url: url,
                                method: 'delete',
                                data: {
                                    _id: row._id
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
      
      loadPage() {
         this.loading = false
        let url   = `api/safeIP`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            type: 2
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
       queryBtn(){
            this.current = 1
            this.loadPage()
        },
   
     
     
    },
    mounted: function () {
      this.loadPage()
      this.loading = false
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        columns4: [{
            type: 'index',
            title:'序号',
            width: 70,
            align: 'center',
          },
          {
            title: 'IP',
            align: 'center',
            key: 'ip',
          },
          {
            title: '用户',
            align: 'center',
            key: 'username'
          },
           {
            title: '添加时间',
            align: 'center',
            key: 'create_time'
          },
          {
            title: '操作',
            slot: 'action',
            width: 200,
            align: 'center'
          }
        ],
        //查询表单的初始值
        queryForm: {
          queryStartDate: '',
          queryEndDate:'',
          ip: '',
          username: '',
        },
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/security/IPList.vue